<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="atendeOutrosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Outros Atendimentos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="text-right mb-3">
                            <button type="button" class="btn btn-outline-primary" @click="entregar ()" :disabled="$store.state.loading" id="entregar-button" title="Entregar Material">
                                <i class="fa-solid fa-hand-holding-droplet fa-fw"></i>
                            </button>
                        </div>

                        <template v-if="dados">

                            <ul class="list-group" v-for="(outro, iox) in dados" :key="iox">
                                <li class="list-group-item d-flex justify-content-between">
                                    <div>
                                        <div v-if="outro.paciente && tem_numeros(outro.st_nome)">
                                            <span class="lead">
                                                {{ outro.paciente.st_nome }}
                                            </span>
                                            <div>
                                                {{ outro.st_nome }}
                                            </div>
                                        </div>
                                        <div class="lead" v-else>{{ outro.st_nome }}</div>
                                        <div>
                                            <i class="fas fa-clock fa-fw mr-2"></i> 
                                            {{ outro.dt_inicio.substr(11,5) }}
                                        </div>
                                        <div>
                                            <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
                                            {{ outro.medico.st_nome_exibicao }}
                                        </div>
                                        <div class="text-muted small">{{ outro.st_observacoes }}</div>
                                    </div>
                                    <div class="text-right">
                                        <div class="d-flex justify-content-end">
                                            <button type="button" class="btn btn-outline-danger btn-sm"
                                                @click="remover(outro)"
                                                v-if="outro.id_etapa_atendimento != 7">
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                            <div class="ml-1">
                                                <az-audit-log-button 
                                                    sizing="sm"
                                                    model="atendimentoOutro" 
                                                    :id="outro.id_atendimento_outro" />
                                            </div>
                                            <button type="button" class="btn btn-sm btn-outline-primary ml-1" @click="entregar(outro)" v-if="recepcao" :disabled="$store.state.loading" title="Entregar Material">
                                                <i class="fa-solid fa-hand-holding-droplet fa-fw"></i>
                                            </button>
                                        </div>
                                        <h4 v-if="outro.etapa" class="mt-2">
                                            <span class="badge badge-secondary">
                                                {{ outro.etapa.st_etapa_atendimento }}
                                            </span>
                                        </h4>
                                        <div class="mt-1" v-if="outro.id_atendimento">
                                            <a href="#" @click.prevent="verColeta(outro)" class="card-link" v-if="coleta">
                                                #{{ outro.id_atendimento }}
                                            </a>
                                            <span v-else>
                                                #{{ outro.id_atendimento }}
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>  

        <paciente-busca-entrega ref="busca" @verColeta="verColeta" />  
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import PacienteBuscaEntrega from '../laboratorio/PacienteBuscaEntrega.vue';

export default {
    data() { 
        return { 
            dados: null,
        };
    },

    components: { 
        AzAuditLogButton, 
        PacienteBuscaEntrega, 
    },

    props: ['coleta', 'recepcao'], 

    methods: { 
        tem_numeros (texto) { 
            if ( !texto )
                return false; 

            return /\d/.test(texto);
        },

        verColeta (item) { 
            this.$emit('verColeta', item);
        },

        abrir(outros) { 
            this.dados = _.cloneDeep(outros);

            $('#atendeOutrosModal').modal('show');
        },

        entregar(outro = null) { 
            $('.modal').modal('hide');

            this.$refs.busca.abrir(outro);
        },

        coleta_abrir (referencia, id_recepcao) { 
            this.dados = null;
            $('#atendeOutrosModal').modal('show');

            this.$util.load(this, { 
                service: 'atendimento_outros',
                func: 'index', 
                parms: {
                    data: referencia,
                    coleta: true,
                    id_recepcao: id_recepcao, 
                }, 
                loadTo: res => { 
                    this.dados = res;
                }
            });

        },
        
        remover(outro) { 
            if ( !confirm('Confirma a remoção do registro?') ) 
                return;

            let info = _.cloneDeep(outro);
            info.fl_ativo = false;

            this.$util.atualizar(this, { 
                service: 'atendimento_outros',
                dados: info,
                modal: 'atendeOutrosModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },
    }
}
</script>